// extracted by mini-css-extract-plugin
module.exports = {"gif":"k_W","gif--wrapped":"k_X"};